module.exports = __webpack_public_path__ + "static/home1-infobar-ca2cea173a5f576ae1b6f8c77f9e6ea3.png";